// ─── Shared ServerItemsEmptyState for sync conflict views ───────────────────
//
// Used when the backend hasn't projected items/payments in the server_version
// (legacy conflicts written before G2.23 shipped).

export interface ServerItemsEmptyStateProps {
  label: string;
}

export function ServerItemsEmptyState({ label }: ServerItemsEmptyStateProps) {
  return (
    <div
      className="rounded-xl bg-neutral-100/60 dark:bg-neutral-800/40 p-6 flex flex-col items-center justify-center text-center min-h-[140px]"
      role="note"
      aria-label="Server data unavailable"
    >
      <svg
        className="h-6 w-6 text-neutral-400 dark:text-neutral-500 mb-2"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M18.364 5.636a9 9 0 010 12.728M1 1l22 22M16.5 16.5A5 5 0 006.09 8.09" />
      </svg>
      <p className="text-sm font-medium text-neutral-600 dark:text-neutral-300">
        Server {label} not loaded
      </p>
      <p className="text-xs text-neutral-500 dark:text-neutral-400 mt-1 max-w-[240px]">
        This conflict was recorded before server-side line items were available.
        Only header totals are compared. Newer conflicts include full server data.
      </p>
    </div>
  );
}
